import { Card, CardContent } from "@/components/ui/card";

export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10" data-testid="terms-page">
      <p className="text-xs uppercase tracking-widest text-[#C25934] font-medium mb-2">
        Legal
      </p>
      <h1 className="font-['Outfit'] text-4xl font-semibold tracking-tight mb-2">
        Terms of Service
      </h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: February 2026</p>

      <Card className="border-[#E5E7EB]">
        <CardContent className="p-8 prose prose-neutral max-w-none">
          <h2>1. What ClaimScope is</h2>
          <p>
            ClaimScope is a software platform that helps property owners
            document, track, and settle insurance claims. We are not an
            insurance carrier, a law firm, or a licensed public adjuster in
            every jurisdiction — we are a tool that helps you work with those
            professionals.
          </p>

          <h2>2. Your account</h2>
          <p>
            You&apos;re responsible for keeping your login safe. If someone
            else accesses your account because you shared your password, we
            can&apos;t be held responsible for what they do. Tell us
            immediately at{" "}
            <a
              href="mailto:security@claimscope.app"
              className="text-[#C25934] hover:underline"
            >
              security@claimscope.app
            </a>{" "}
            if you suspect a breach.
          </p>

          <h2>3. Fees</h2>
          <p>
            <strong>Per-claim success fee:</strong> If ClaimScope helps you
            secure a settlement and you mark the claim &ldquo;approved,&rdquo;
            we charge a percentage-based success fee (default 15%, disclosed
            in your claim). Payment is collected via Stripe.
          </p>
          <p>
            <strong>Contractor memberships:</strong> Contractors who subscribe
            to ClaimScope Pro pay a monthly recurring fee disclosed at checkout.
            Cancel anytime from your profile; access continues through the
            current period.
          </p>
          <p>
            All fees are non-refundable except as required by applicable law.
            If you believe you&apos;ve been charged in error, contact{" "}
            <a
              href="mailto:billing@claimscope.app"
              className="text-[#C25934] hover:underline"
            >
              billing@claimscope.app
            </a>
            .
          </p>

          <h2>4. Acceptable use</h2>
          <ul>
            <li>No fake claims, forged documents, or fraudulent photos.</li>
            <li>No harassment of other users or our support staff.</li>
            <li>No scraping, reverse engineering, or bypassing rate limits.</li>
            <li>No uploading illegal content or material you don&apos;t own.</li>
          </ul>
          <p>
            We&apos;ll terminate accounts that violate these terms and may
            cooperate with law enforcement on fraud investigations.
          </p>

          <h2>5. Your content</h2>
          <p>
            You own everything you upload — photos, documents, notes. You grant
            ClaimScope a license to store, display, and transmit that content
            only to run the service for you (e.g., generate claim packets, send
            them to adjusters you pick). We do not claim rights beyond that.
          </p>

          <h2>6. No professional advice</h2>
          <p>
            Information provided in the app — carrier guides, AI damage
            analysis, timeline estimates — is informational only. It is not
            legal, insurance, or tax advice. For complex claims, engage a
            licensed public adjuster or attorney.
          </p>

          <h2>7. Warranty disclaimer</h2>
          <p>
            The service is provided &ldquo;as is.&rdquo; We do our best to
            keep it running, but we don&apos;t warrant uninterrupted access or
            specific outcomes. Your insurance settlement depends on many
            factors outside our control.
          </p>

          <h2>8. Limitation of liability</h2>
          <p>
            To the maximum extent allowed by law, ClaimScope&apos;s total
            liability is capped at the fees you paid in the 12 months before
            the claim. We&apos;re not liable for indirect, consequential, or
            punitive damages.
          </p>

          <h2>9. Governing law</h2>
          <p>
            These terms are governed by the laws of the State of Florida,
            United States. Disputes will be resolved in the state or federal
            courts in Miami-Dade County.
          </p>

          <h2>10. Changes</h2>
          <p>
            We may update these terms. Material changes will trigger an
            in-app notice + an email. Continued use after the change means you
            accept it.
          </p>

          <h2>11. Contact</h2>
          <p>
            Questions? Email{" "}
            <a
              href="mailto:legal@claimscope.app"
              className="text-[#C25934] hover:underline"
            >
              legal@claimscope.app
            </a>
            .
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
